import React from 'react';
import { TransportFeeMain } from './transport-fee-main';

const TransportFee = ({
  contTypeList,
  dataFeeMainTransport,
  setDataFeeMainTransport,
  locationSelected,
  isPartner = false,
  reloadAfterUpdate,
  contractStatus = 0,
  isNew = false,
  valueDetail,
}) => {
  return (
    <>
      <TransportFeeMain
        contTypeList={contTypeList}
        dataFeeMainTransport={dataFeeMainTransport}
        setDataFeeMainTransport={setDataFeeMainTransport}
        locationSelected={locationSelected}
        isPartner={isPartner}
        reloadAfterUpdate={reloadAfterUpdate}
        contractStatus={contractStatus}
        isNew={isNew}
        valueDetail={valueDetail}
      />
    </>
  );
};

export { TransportFee };
